import { render, staticRenderFns } from "./ManageAssetPagination.vue?vue&type=template&id=c3c37666&scoped=true&"
import script from "./ManageAssetPagination.vue?vue&type=script&lang=js&"
export * from "./ManageAssetPagination.vue?vue&type=script&lang=js&"
import style0 from "./ManageAssetPagination.vue?vue&type=style&index=0&id=c3c37666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c37666",
  null
  
)

export default component.exports